/**
 * @file    UnsupportedWidgetPlaceholder.tsx
 * @scope   VIEW
 * @summary Safe placeholder for engine widgets this client cannot render (unknown/gated-off
 *          subtype, or a render error caught by EngineRenderBoundary).
 * @consumes Nothing.
 * @produces UnsupportedWidgetPlaceholder
 * @sideEffects None.
 */
import React from 'react';
import './UnsupportedWidgetPlaceholder.scss';

type UnsupportedWidgetPlaceholderProps = {
  /** Persisted discriminator, shown to help support diagnose the widget. */
  chartTypeId?: string;
};

const UnsupportedWidgetPlaceholder: React.FC<UnsupportedWidgetPlaceholderProps> = ({
  chartTypeId,
}) => (
  <div className="unsupported-widget-placeholder" role="status">
    <span>This widget type is not available.</span>
    {chartTypeId && <span className="unsupported-widget-placeholder__id">{chartTypeId}</span>}
  </div>
);

export default UnsupportedWidgetPlaceholder;
